// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --Orange: #fe6100;
  --Green: #87bc45;
  --Red: #e00606;
  --WhiteSmoke: #f5f5f5;
  --White: #fff;
  --StockOrange: #ff7b29;
  --StockRed: #e00606;
  --SaddleBrown: #833505;
  --TotalBlack: #000000;
  --HightEmphasis: #212121;
  --LightBlack: #0f1d3e;
  --MediumEmphasis: #666;
  --LowEmphasis: #9e9e9e;
  --Gray88: #e0e0e0;
  --Gray85: #d9d9d9; }

.datePicker_wrapper__M1n48 {
  position: relative; }

.datePicker_picker__7ey92 {
  position: absolute;
  top: 40px;
  right: 0;
  box-shadow: 0px 4px 8px rgba(73, 72, 55, 0.5);
  border-radius: 4px;
  background-color: var(--White);
  overflow: hidden;
  z-index: 102; }
  .datePicker_picker_buttons__GUvVP {
    border-top: 1px solid #eff2f7;
    padding: 9px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 20px; }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.scss","webpack://./src/components/datePicker/datePicker.module.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAS;EACT,gBAAQ;EACR,cAAM;EACN,qBAAa;EACb,aAAQ;EACR,sBAAc;EACd,mBAAW;EACX,sBAAc;EAGd,qBAAa;EACb,wBAAgB;EAChB,qBAAa;EACb,sBAAiB;EACjB,sBAAc;EAGd,iBAAS;EACT,iBAAS,EAAA;;AClBX;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY,EAAA;EACZ;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA","sourcesContent":[":root {\n  // Product\n  --Orange: #fe6100;\n  --Green: #87bc45;\n  --Red: #e00606;\n  --WhiteSmoke: #f5f5f5;\n  --White: #fff;\n  --StockOrange: #ff7b29;\n  --StockRed: #e00606;\n  --SaddleBrown: #833505;\n\n  // On Surface\n  --TotalBlack: #000000;\n  --HightEmphasis: #212121;\n  --LightBlack: #0f1d3e;\n  --MediumEmphasis: #666;\n  --LowEmphasis: #9e9e9e;\n\n  // Border\n  --Gray88: #e0e0e0;\n  --Gray85: #d9d9d9;\n}\n","@import 'src/styles/colors.scss';\n\n.wrapper {\n  position: relative;\n}\n\n.picker {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  box-shadow: 0px 4px 8px rgba(73, 72, 55, 0.5);\n  border-radius: 4px;\n  background-color: var(--White);\n  overflow: hidden;\n  z-index: 102;\n  &_buttons {\n    border-top: 1px solid #eff2f7;\n    padding: 9px 20px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `datePicker_wrapper__M1n48`,
	"picker": `datePicker_picker__7ey92`,
	"picker_buttons": `datePicker_picker_buttons__GUvVP`
};
export default ___CSS_LOADER_EXPORT___;
